import styled, { css } from 'styled-components';
import { theme } from '../../../../styles/theme';
import { SvgIcon } from '../../../Icon';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid ${theme.colors.border};
  border-radius: 4px;
  width: 100%;
  margin: 8px 0;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
  padding: 8px 8px 8px 12px;
  gap: 8px;
  border-bottom: 1px solid ${theme.colors.border};
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  padding: 8px 8px 8px 12px;
`;

export const Title = styled.div`
  font-size: 14px;
  color: ${theme.colors.secondary900};
`;

export const Description = styled.div`
  font-size: 10px;
  color: ${theme.colors.secondary600};
`;

export const RefreshDate = styled.div`
  font-size: 10px;
  color: ${theme.colors.secondary800};
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 8px;
`;

export const Name = styled(Row)<{ $isDisabled?: boolean }>`
  font-size: 12px;
  font-weight: 500;

  ${({ $isDisabled }) =>
    !$isDisabled &&
    css`
      &:hover {
        cursor: pointer;
        color: ${theme.colors.mainBlue};
      }
    `}

  ${({ $isDisabled }) =>
    $isDisabled &&
    css`
      cursor: not-allowed;
      color: ${theme.colors.secondary600};
    `}
`;

export const DragHandle = styled(SvgIcon)`
  cursor: grab;
`;
